import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { Target, ChevronRight } from 'lucide-react';
import { PFP } from './styles';
import { GoalBadge } from './ParentAppGoals';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

// Home-page entry point for "My Child's Goals".
export default function MyChildGoalsCard({ childId }) {
  const navigate = useNavigate();
  const [data, setData] = useState(null);

  useEffect(() => {
    if (!childId) return;
    axios.get(`${API}/parent-app/children/${childId}/goals`, {
      headers: { Authorization: `Bearer ${localStorage.getItem('token')}` },
    }).then((r) => setData(r.data)).catch(() => setData(null));
  }, [childId]);

  if (!childId) return null;
  const parentActive = (data?.parent_goals || []).filter((g) => g.status === 'active');
  const therapist = data?.therapist_goals || [];
  const preview = [...parentActive.map((g) => ({ ...g, source: 'parent' })), ...therapist].slice(0, 3);

  return (
    <button
      onClick={() => navigate(`/parent-app/goals?child=${childId}`)}
      className={`${PFP.card} ${PFP.cardHover} p-5 w-full text-left block`}
      data-testid="my-child-goals-card"
    >
      <div className="flex items-center justify-between">
        <h3 className="font-serif text-xl text-[#3a2f4f] flex items-center gap-2"><Target className="w-5 h-5 text-[#7C6F9C]" /> My Child&apos;s Goals</h3>
        <ChevronRight className="w-5 h-5 text-stone-400" />
      </div>
      <p className="text-sm text-stone-600 mt-1">Goals you choose and goals your therapist shares help shape some of your daily play ideas.</p>
      {preview.length > 0 ? (
        <ul className="mt-3 space-y-1.5">
          {preview.map((g) => (
            <li key={`${g.source}-${g.title}`} className="flex items-center gap-2 text-sm text-stone-800"><GoalBadge source={g.source} /> <span className="truncate">{g.title}</span></li>
          ))}
        </ul>
      ) : (
        <p className="text-sm text-[#7C6F9C] mt-3 font-medium" data-testid="my-child-goals-empty">Choose a goal that matters to your family →</p>
      )}
    </button>
  );
}
